import styled from "styled-components";
import { Pagination, PaginationProps, Table } from "antd";

export const ContainerTable = styled.div`
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  padding: 0 40px 20px 40px;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    height: 55px;
    top: 0;
    left: 0;
    background: #EAEAEA;
    width: 100%;
  }

  @media screen and (max-width: 1024px) {
    & {
      padding: 0 17px;
      border-radius: 20px;
    }

    &:before {
      height: 60px;
    }
  }
`;
export const ContainerTableAddress = styled.div`
  background: #ffffff;
  overflow: hidden;
  padding: 30px 50px 20px 50px;
  position: relative;
  border-radius: 20px;
  margin-top: 15px;
`;
export const ContainerTableHome = styled.div`
  overflow: hidden;
`;
export const PaginationView = styled(Pagination).attrs({
  showSizeChanger: false,
})`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px 0;

  & > li {
    width: 28px;
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .ant-pagination-item {
    width: 28px !important;
    height: 28px;
    border: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #848484;
    line-height: 14px;
    background-color: #f5f5f5;

    &:hover {
      a {
        color: #F12E11;
      }
    }

    & a {
      font-weight: 400;
      font-size: 16px;
      @media screen and (max-width: 1024px) {
        & {
        }
      }
    }

    @media screen and (max-width: 1024px) {
      & {
        width: 38px;
        height: 38px;
      }
    }
  }

  & .ant-pagination-jump-next, .ant-pagination-jump-next-custom-icon {
    svg {
      stroke: #F12E11 !important;
      fill: #F12E11 !important;
    }
  }

  & .ant-pagination-item-active {
    width: 28px !important;
    height: 28px;
    border-radius: 50%;
    font-weight: 400;
    font-size: 16px;
    position: relative;
    background: #F12E11;

    &:before {
      content: "";
      position: absolute;
      width: 26px;
      height: 26px;
      top: 1px;
      left: 1px;
      background-color: #f5f5f5;
      border-radius: 50%;
      z-index: 1;
    }

    & > a {
      color: #F12E11;
      z-index: 2;
    }

    @media screen and (max-width: 1024px) {
      & {
        width: 28px;
        height: 28px;
      }
    }
  }
`;
export const TableView = styled(Table).attrs(
//   (props) => {
//   return {
//     showSorterTooltip: false,
//     rowKey: (record) => record?.tid || record?.id,
//     dataSource: (props.dataSource || []).map((item, index) => {
//       item.tid = index;
//       return item;
//     }),
//   };
// }
)`
  & .ant-table {
    background-color: rgba(0, 0, 0, 0);
  }

  & .ant-table-tbody > tr {
    cursor: ${(props) => (props?.isClickRow ? "pointer" : "default")};
  }

  & .ant-table-tbody > tr > td {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    padding: 21px 16px;
    vertical-align: middle;

    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
        padding: 20px 10px;
      }
    }
  }

  & .ant-table-tbody > tr > td:first-child,
  & .ant-table-thead > tr > th:first-child {
    padding-left: 0 !important;
  }
  & .ant-table-tbody > tr > td.table-head-start,
  & .ant-table-thead > tr > th.table-head-start {
    padding-left: 25px !important;
  }

  & .ant-table-tbody > tr > td:last-child,
  & .ant-table-thead > tr > th:last-child {
    padding-right: 0 !important;
  }
  & .ant-table-tbody > tr > td.transaction_code,
  & .ant-table-thead > tr > th.transaction_code {
    padding-left: 30px;
    @media screen and (max-width: 1120px) {
      & {
        padding-left: 0;
      }
    }
  }

  .ant-pagination-disabled {
    opacity: 0.3;
  }

  & .ant-table-thead > tr > th,
  & .ant-table-thead th.ant-table-column-has-sorters:hover {
    background-color: rgba(0, 0, 0, 0);
    padding: 12px 16px;
    height: 55px;
    color: #000000;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    @media screen and (max-width: 1366px) {
      & {
        height: 55px;
      }
    }
    @media screen and (max-width: 1024px) {
      & {
        height: 60px;
      }
    }
  }

  & .ant-table-thead > tr > th:before {
    content: none !important;
  }

  & .ant-table .ant-table-container::before,
  .ant-table .ant-table-container::after {
    display: none;
  }

  & .ant-table-column-sorters {
    justify-content: flex-start !important;
  }

  & .justify-end .ant-table-column-sorters {
    justify-content: flex-end !important;
  }

  & .justify-center .ant-table-column-sorters {
    justify-content: center !important;
  }

  & .btc-value.ant-table-column-has-sorters {
    width: 200px;
    @media screen and (max-width: 1024px) {
      & {
        width: auto;
      }
    }
    & .ant-table-column-sorters {
      justify-content: flex-end !important;
    }
  }

  & .btc-value.flex-start.ant-table-column-has-sorters {
    width: 200px;
    @media screen and (max-width: 1024px) {
      & {
        width: auto;
      }
    }
    & .ant-table-column-sorters {
      justify-content: flex-start !important;
    }
  }

  & .text-center.ant-table-column-has-sorters {
    & .ant-table-column-sorters {
      justify-content: center !important;
    }
  }

  & .ant-table-column-title,
  & .ant-table-cell {
    flex: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    color: #000000;
    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
      }
    }
  }

  & .anticon {
    color: black;
  }

  & .anticon.active {
    color: #F12E11;
  }

  & .ant-table-tbody > tr:last-child > td {
    border-color: rgba(0, 0, 0, 0);
  }
`;

export const TableViewHome = styled(Table).attrs((props) => {
  return {
    showSorterTooltip: false,
    rowKey: (record) => record?.tid || record?.id || "",
    dataSource: (props.dataSource || []).map((item, index) => {
      item.tid = index;
      return item;
    }),
  };
})`
  & .ant-table {
    background-color: rgba(0, 0, 0, 0);
  }

  & .ant-table-tbody > tr {
    cursor: ${(props) => (props?.isClickRow ? "pointer" : "default")};
  }

  & .ant-table-tbody > tr > td {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    padding: 23px 16px;
    vertical-align: middle;
    @media screen and (max-width: 1366px) {
      & {
        padding: 16px 16px;
      }
    }
    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
        padding: 20px 10px;
      }
    }
  }

  /* & .ant-table-tbody > tr > td:first-child,
  & .ant-table-thead > tr > th:first-child {
    padding-left: 0 !important;
  } */

  /* & .ant-table-tbody > tr > td:last-child,
  & .ant-table-thead > tr > th:last-child {
    padding-right: 0 !important;
  } */

  .ant-pagination-disabled {
    opacity: 0.3;
  }

  & .ant-table-thead > tr > th,
  & .ant-table-thead th.ant-table-column-has-sorters:hover {
    background-color: rgba(0, 0, 0, 0);
    padding: 12px 20px;
    height: 55px;
    color: #000000;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    @media screen and (max-width: 1366px) {
      & {
        height: 50px;
      }
    }
    @media screen and (max-width: 1024px) {
      & {
        height: 60px;
      }
    }
  }

  & .ant-table-thead > tr > th:before {
    content: none !important;
  }

  & .ant-table .ant-table-container::before,
  .ant-table .ant-table-container::after {
    display: none;
  }

  & .ant-table-column-title,
  & .ant-table-cell {
    flex: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    color: #000000;
    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
      }
    }
  }

  & .anticon {
    color: black;
  }

  & .anticon.active {
    color: #F12E11;
  }

  & .ant-table-tbody > tr:last-child > td {
    border-color: rgba(0, 0, 0, 0);
  }
`;

export const CellStatus = styled.div.attrs((props) => ({
  className: props.text.toLowerCase().split(" ").join("_"),
}))`
  padding: 0 20px;
  line-height: 30px;
  font-weight: 400;
  font-size: 13px;
  height: 30px;
  border-radius: 30px;
  color: #7e7e7e;
  background: rgba(242, 242, 242, 0.5);
  text-transform: capitalize;
  text-align: center;
  display: inline-flex;
  white-space: nowrap;

  &.v2 {
    padding: 0 12px;
    line-height: 20px;
    font-weight: 400;
    font-size: 10px;
    height: 20px;
  }

  &.failed {
    background: rgba(224, 27, 27, 0.1);
    color: #e5665b;
  }

  &.succeeded,
  &.approved {
    background: #F5AA194D;
    color: #F12E11;
  }

  &.waiting_for_approval {
    background: rgba(188, 45, 189, 0.1);
    color: #bc2dbd;
  }
`;

export const CellType = styled.div.attrs((props) => ({
  className: props.value.split(" ").join("_"),
}))`
  width: 135px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #e01b1b;
  border-radius: 30px;
  text-align: center;
  line-height: 30px;
  font-weight: 400;
  font-size: 13px;
  color: #e01b1b;
  text-transform: capitalize;

  &.withdraw {
    border-color: #485ea8;
    color: #485ea8;
  }

  &.checkout {
    border-color: #338d7d;
    color: #338d7d;
  }
`;

export const paginationRender = (_, type, originalElement) => {
  if (type === "prev") {
    return (
      <a>
        <svg
          width="7"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 1L1 6L6 11"
            stroke="#666666"
            strokeOpacity="1"
            strokeWidth="1.67"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    );
  }
  if (type === "next") {
    return (
      <a>
        <svg
          width="7"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 11L6 6L1 1"
            stroke="#666666"
            strokeWidth="1.67"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    );
  }
  return originalElement;
};
